import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireComponentSquad} from '@tisa-group/models';
import {CarouselModule} from '@tisa-group/client-ui/components/carousel';
import {PlayerTileComponent} from '@tisa-group/client-ui/components/player-tile';
import {SvgIconComponent} from '@tisa-group/client-ui/components/svg-icon';
import {RouterModule} from '@angular/router';
import {TISA_CURRENT_LOCALE} from '@tisa-group/client-ui/tokens';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'tisa-squad',
  imports: [
    CommonModule,
    CarouselModule,
    PlayerTileComponent,
    RouterModule,
    SvgIconComponent,
    TranslateModule,
  ],
  templateUrl: './squad.component.html',
  styleUrl: './squad.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SquadComponent {
  readonly component = input<UmpireComponentSquad | undefined>();

  readonly squadPlayers = computed(() =>
    [...(this.component()?.squad?.squad_players || [])].sort(
      (a, b) => Number(a.number ?? Infinity) - Number(b.number ?? Infinity),
    ),
  );

  readonly teamId = computed(() => this.component()?.squad?.team?.id);

  readonly seasonId = computed(() => this.component()?.squad?.season?.id);

  readonly locale = inject(TISA_CURRENT_LOCALE);

  buttonRightDisabled = signal(false);

  buttonLeftDisabled = signal(true);

  onButtonRightStatusChanges(disabled: boolean) {
    this.buttonRightDisabled.set(disabled);
  }

  onButtonLeftStatusChanges(disabled: boolean) {
    this.buttonLeftDisabled.set(disabled);
  }
}
